import { motion } from "framer-motion";
import secondaryComponents from "../../../../../components/secondaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../../../components/primaryComponents";
import {
  PlatformCreditTable,
  PlatformMetrics,
} from "../../../../../components/secondaryComponents/PlatformCredit";
import { usePlatformCreditHistory } from "./usePlatformCreditHistory";
import { Outlet, useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../routes/pathContants";

const PlatformCreditHistory = () => {
  const {
    queryParams,
    creditTransactions,
    metaDetails,
    creditInfo,
    isLoading,
    isLoadingTnx,
    filterByDate,
    gotoPage,
    filterBySearch,
  } = usePlatformCreditHistory();
  const navigate = useNavigate();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Platform Credit"
      description="View credit history"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Credit Information</h4>
            <p>Manage and track consumption</p>
          </div>

          <div>
            <primaryComponents.Button
              classNames={"btn btn--primary ml-auto"}
              onClick={() =>
                navigate(pathConstants.SETTINGS_PLATFORM_CREDIT_TOPUP)
              }
            >
              Topup Credit
            </primaryComponents.Button>
          </div>

          <secondaryComponents.LoaderHelper
            isLoading={isLoading}
            classNames={"mt-5"}
          >
            <PlatformMetrics creditInfo={creditInfo} />
          </secondaryComponents.LoaderHelper>

          {/* table section */}
          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                classNames={`${globalStyles.searchField}`}
                placeholder="Search by transaction ID"
                trigger={(value) => filterBySearch(value)}
                value={queryParams?.query || ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />

              <div className="ml-auto">
                <primaryComponents.DateRangeInput
                  startDate={queryParams?.start_date}
                  endDate={queryParams?.end_date}
                  onChange={filterByDate}
                  showPlaceholder={true}
                />
              </div>
            </div>

            {/* table section */}
            <secondaryComponents.LoaderHelper
              isLoading={isLoadingTnx}
              classNames="mt-5"
            >
              <PlatformCreditTable
                creditTransactions={creditTransactions}
                metaDetails={metaDetails}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>
        </motion.div>

        <Outlet />
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
export default PlatformCreditHistory;
